<template>
    <v-dialog
        v-model="isOpen"
        max-width="1200"
    >
        <v-card>
            <v-card-title class="headline pb-10">
                Выгрузить пользователей?
            </v-card-title>
            <v-card-text> Выбрано для выгрузки {{tableData.total}} пользователей
                <v-layout row wrap>
                    <v-layout column>
                        <v-checkbox color="info" value="phone" v-model="csvFilters" label="Телефон"></v-checkbox>
                        <v-checkbox color="info" value="email" v-model="csvFilters" label="Почта"></v-checkbox>
                        <v-checkbox color="info" value="name" v-model="csvFilters" label="Имя"></v-checkbox>
                        <v-checkbox color="info" value="surname" v-model="csvFilters" label="Фамилия"></v-checkbox>
                        <v-checkbox color="info" value="second_name" v-model="csvFilters" label="Отчество"></v-checkbox>
                        <v-checkbox color="info" value="created_at" v-model="csvFilters" label="Дата регистрации"></v-checkbox>
                    </v-layout>
                    <v-layout column>
                        <v-checkbox color="info" value="aff_sub1" v-model="csvFilters" label="Aff_sub1"></v-checkbox>
                        <v-checkbox color="info" value="aff_sub2" v-model="csvFilters" label="Aff_sub2"></v-checkbox>
                        <v-checkbox color="info" value="aff_sub3" v-model="csvFilters" label="Aff_sub3"></v-checkbox>
                        <v-checkbox color="info" value="aff_sub4" v-model="csvFilters" label="Aff_sub4"></v-checkbox>
                        <v-checkbox color="info" value="aff_sub5" v-model="csvFilters" label="Aff_sub5"></v-checkbox>
                    </v-layout>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="clearCsvFilters()" color="info">Очистить фильтры</v-btn>
                <v-btn text @click="close()">Закрыть</v-btn>
                <v-btn text color="primary" @click="createCSV()">Выгрузить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
    name: 'confirmCSVModal',
    components: {
        OverlayLoader,
    },
    props: [
        'params'
    ],
    data() {
        return {
            csvFilters: ['phone'],
        };
    },
    computed: {
        isOpen: {
            get(){
                return this.$store.getters.IS_CONFIRM_CSV_MODAL_OPENED;
            },
            set(){
                this.$store.dispatch('CONFIRM_CSV_MODAL', false);
            }
        },
        tableData() {
            return this.$store.getters.GET_TABLE_DATA;
        },
    },
    methods: {
        close() {
            this.$store.dispatch('CONFIRM_CSV_MODAL', false);
            this.csvFilters = ['phone'];
        },
        createCSV() {
            let params = {
                filters: JSON.parse(JSON.stringify(this.$store.getters.GET_USERS_REQUEST_FILTERS)),
                csvFilters: [this.csvFilters],
            };
            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }
            this.$store.dispatch('CREATE_CSV', params)
                .then((data) => {
                    var fileLink = document.createElement('a');
                    fileLink.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(data.data);
                    fileLink.download = 'output.csv';
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    this.$toast.success('Пользователи выгружены');
                    this.$store.dispatch('CONFIRM_CSV_MODAL', false);
                })
                .catch((error) => {
                    if (error.response.data.message === 'Empty result') {
                        this.$toast.error("Пустой набор данных");
                    }
                    else {
                        this.$toast.error("Ошибка сервера");
                    }
                });
        },
        clearCsvFilters() {
            this.csvFilters = ['phone'];
        },
    },
};
</script>
